import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection } from '@gik/ui';
import CompetitorsPreview from './CompetitorsPreview';

const blockName = 'competitors-preview-section';

export default function CompetitorsPreviewSection(): React.ReactElement {
  const bem = bemBlock(blockName);

  return (
    <PageSection variant="lightblue" className={bem()} contained>
      <CompetitorsPreview />
    </PageSection>
  );
}
